<mat-card fxLayout="row" fxLayoutAlign="space-around center" style="height: 100%; width: 100%; box-shadow: none">
    <ngx-charts-bar-vertical-2d [animations]="false" [scheme]="scheme" [results]="data" title="''" [view]="view" [xAxis]="xAxis" [barPadding]="barPadding" [groupPadding]="groupPadding">
    </ngx-charts-bar-vertical-2d>
</mat-card>